import { API } from "@/lib/api";

export const DOCUMENTS = [
  { id: "sales-deck", group: "sales", title: "Sales Deck", version: "v1", pages: 8, file: "pulse-commissioning-sales-deck-v1.pdf", text: "The full presentation of Pulse Commissioning." },
  { id: "sales-sheet", group: "sales", title: "Sales Sheet", version: "v1", pages: 1, file: "pulse-commissioning-sales-sheet-v1.pdf", text: "A one-page summary to share with your team." },
  { id: "system-manual", group: "manual", private: true, title: "System Manual", version: "v1", pages: 5, file: "pulse-commissioning-system-manual-v1.pdf", text: "How to set up and use Pulse Commissioning. For signed-in customers." },
];

export const docUrl = (d) => (d.private ? `${API}/documents/manual` : `/docs/${d.file}`);
